import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import FollowButton, { FollowButtonProps } from '.';
import { FollowType } from '../../../utils/backend-api/follow';

const FollowButtonWithQueryClientWrapper = (props: FollowButtonProps) => {
  return (
    <QueryClientProvider client={new QueryClient()}>
      <FollowButton {...props} followType={FollowType.Entity} />
    </QueryClientProvider>
  );
};

export default FollowButtonWithQueryClientWrapper;
